module.exports = {"pathContext":{"name":"NotificationMetadata","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"encounterId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-notification-metadata.json
// module id = 1874
// module chunks = 33424470155352